export function MascaraTelefone(value) {
    if (!value) return "";

    // Remove tudo que não é número
    value = value.replace(/\D/g, "");

    // Limita a 10 dígitos (DDD + telefone de 8 dígitos)
    if (value.length > 10) value = value.slice(0, 10);

    // Aplica a máscara: (XX) XXXX-XXXX
    if (value.length <= 2) {
        return value.replace(/^(\d{0,2})$/, "($1");
    }

    if (value.length <= 6) {
        return value.replace(/^(\d{2})(\d+)$/, "($1) $2");
    }

    return value.replace(/^(\d{2})(\d{4})(\d{0,4})$/, "($1) $2-$3");
}